import { IonContent, IonPage } from '@ionic/react';
import { useEffect } from 'react';

import Loading from '@/components/common/loading/Loading';
import Logo from '@/components/common/logo/Logo';
import Padding from '@/components/common/padding/Padding';
import { APP_STORE_URL } from '@/utils/constants';

const Ios: React.FC = () => {
  useEffect(() => {
    window.location.href = APP_STORE_URL;
  }, []);

  return (
    <IonPage id="ios">
      <IonContent>
        <Padding>
          <Logo />
          <Loading />
        </Padding>
      </IonContent>
    </IonPage>
  );
};

export default Ios;
